<!-- 列表详情组件 -->
<template>
  <div class="detail">
    <div style="position: relative" v-if="detailData.img">
      <div>
        <van-image
          :width="'100%'"
          height="180"
          fit="cover"
          :src="detailData.img"
        />
      </div>
      <div class="detail-header">
        <h4>《职场沟通与高校协作》主题讲座</h4>
        <div>
          <van-icon name="clock-o" :color="'var(--theme-primary)'" />
          <span>2025年8月14日</span>
        </div>
        <div>
          <van-icon name="contact-o" :color="'var(--theme-primary)'" />
          <span>李四</span>
        </div>
        <div>
          <van-icon name="location-o" :color="'var(--theme-primary)'" />
          <span>2025年8月14日</span>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <van-icon name="smile-o" :color="'var(--theme-primary)'" />
            <span>已报名31人/ 不限制名额</span>
          </div>
          <span style="color: var(--theme-primary)">查看全部报名</span>
        </div>
      </div>
    </div>

    <div class="detail-content">
      <van-image
        :width="'100%'"
        height="180"
        fit="cover"
        :src="detailData.img"
      />
      <p style="margin-top: 10px">
        在职场中，沟通不畅常让协作受阻，项目进度拖沓，同事关系也陷入僵局。想打破这一困局，提升沟通与协作能力迫在眉睫。为此，我们精心筹备了《职场沟通与高效协作》主题讲座。
        讲座中，资深职场专家将从剖析沟通本质入手，点明日常沟通误区，分享倾听、表达、反馈等实用技巧，如向上沟通时精准把握领导意图，高效汇报工作；跨部门协作时，化解矛盾冲突，达成共赢。通过鲜活案例与情景模拟，让您沉浸式体验沟通魅力，即学即用。
        无论是初入职场的新人，还是渴望突破协作瓶颈的资深员工，这场讲座都将为您赋能，助您打造高效团队，在职场中脱颖而出。
      </p>
    </div>
    <div class="submit-button">
      <van-button round type="info" block>报名参加</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail2",
  props: {
    datas: Object,
  },
  data() {
    return {
      detailData: {},
    };
  },

  created() {
    // 获取文章详情
    console.log("详情222222222222222", this.datas, this.detailData);
    this.getArticleDetail();
  },
  methods: {
    // 获取文章详情
    async getArticleDetail() {
      const res = await this.$api.admin.article.getArticleDetailAPI({
        id: this.$route.query.pageId,
      });
      if (res.code == 200) {
        console.log(
          "获取文章详情1111111111111结果",
          this.$route.query,
          res.data,
        );
        this.detailData = res.data;
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .detail-content {
  .van-image {
    .van-image__img {
      border-radius: 10px;
    }
  }
}
.detail {
  border: 4px solid red;
  position: relative;
  height: 100%;
  .detail-header {
    background: #fff;
    margin-top: -35px;
    position: relative;
    padding: 0 2;
    border-radius: 5px;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 13px;
    display: flex;
    gap: 5px;
    padding: 15px;
    flex-direction: column;
    span {
      padding-left: 10px;
    }
  }
  .detail-content {
    border-radius: 5px;
    background-color: #fff;
    padding: 10px;
    margin: 10px;
  }
  .submit-button {
    background-color: #fff;
    // position: fixed;
    // bottom: 0;
    // left: 0;
    // right: 0;
    padding: 10px;
  }
}
</style>
